import script from "./UiAuthBrandPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UiAuthBrandPanel.vue?vue&type=script&setup=true&lang=js"

import "./UiAuthBrandPanel.vue?vue&type=style&index=0&id=ab214606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab214606"]])

export default __exports__